export default __webpack_public_path__ + "e2d52ccabeec5d051eebe50479ba0d07.svg";